import { jwtDecode } from "jwt-decode";

import SecureStorage from "$src/core/services/secure-storage";
import isTokenValid from "$src/core/utils/auth/is-token-valid";

const isJwt = (token: string): boolean => {
  try {
    jwtDecode(token);
    return true;
  } catch {
    return false;
  }
};

const hasValidRefreshToken = async (): Promise<boolean> => {
  try {
    const refreshToken = SecureStorage.get("auth.refreshToken");
    if (!refreshToken) return false;

    if (isJwt(refreshToken)) {
      return isTokenValid(refreshToken);
    }

    return refreshToken.length > 0;
  } catch {
    return false;
  }
};

export default hasValidRefreshToken;
